/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import swal from 'sweetalert2';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import Card from '../../Card';
import { paiementManuel, obtenirProprietaire, obtenirHistorique } from '../../../App_Code/API';
import { toEuros } from '../../../App_Code/Utils';
import * as HttpStatus from '../../../App_Data/HttpStatus';
import * as ProAct from '../../../Actions/ProActions';

class CardPaiementPrlManuel extends Component {
    constructor() {
        super();

        this.handleBlur = this.handleBlur.bind(this);
    }

    ValiderPaiement = () => {
        const MontantPrl = this.props.SoldeAPrl;
        const { SoldeAPayer } = this.props;

        if (MontantPrl === undefined || MontantPrl > SoldeAPayer || MontantPrl < 10) {
            swal('Erreur', `Le montant saisi n'est pas correct. Il doit être compris entre 10€ et ${toEuros(SoldeAPayer)} €`, 'error');
            return;
        }
        paiementManuel(this.props.Pro.Ind.Nom, MontantPrl, SoldeAPayer).then((response) => {
            if (!response) return;
            if (response.status === HttpStatus.OK) {
                swal('Succès', `Votre paiement de ${toEuros(MontantPrl)} € a bien été pris en compte.`, 'success');
                obtenirProprietaire().then((pro) => {
                    this.props.actions.proAjout(pro);
                });
                obtenirHistorique().then((hist) => {
                    this.props.actions.proHistoAjout(hist);
                });
                this.props.history.push('/MesInformations');
            } else {
                const footer =
                    response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : '';
                swal({
                    type: 'error',
                    title: 'Erreur',
                    text: "Une erreur s'est produite lors de la validation du paiement.",
                    footer,
                });
            }
        });
    };

    handleBlur(e) {
        const num = parseFloat(e.target.value);
        this.props.setSoldeAPrl(num.toFixed(2));
    }

    render() {
        return (
            <Card Titre="Mon paiement à la demande">
                <p>Vous avez opté pour le prélèvement à la demande. Pour demander le prélèvement, cliquez ci-dessous. <br />
                <i>Vous serez débité de ce montant lors du prochain prélèvement</i></p>
                { this.props.SoldeAPayer >= 10 ? <p>Il est conseillé de payer le montant proposé.</p> : null}
                { this.props.SoldeAPayer >= 10 ?
                    <div>
                        <label className="text-muted">Montant à prélever :</label>
                        <div className="form-inline justify-content-center mb-3">
                            <div className="input-group mb-1 w-50 col-md-8 col-12" >
                                <input
                                    className="text-right form-control"
                                    type="number"
                                    min="10"
                                    max={this.props.SoldeAPayer}
                                    value={this.props.SoldeAPrl}
                                    onChange={(e) => { this.props.setSoldeAPrl(e.target.value); }}
                                    onBlur={this.handleBlur}
                                    step={0.01}
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">€</span>
                                </div>
                            </div>
                            <button onClick={this.ValiderPaiement} className="btn btn-success col-md-4 col-5 mb-1" style={{ maxWidth: 200, margin: 'auto' }}>
                                Valider le paiement
                            </button>
                        </div>
                    </div>
                    : this.props.SoldeAPayer <= 0 ?
                        <p className="text-muted">Vous êtes à jour, il n&apos;y a rien à payer.</p> :
                        <p className="text-muted">Le montant minimum pour faire un virement manuel est de 10 €. Les {toEuros(this.props.SoldeAPayer)} € restants seront reportés sur votre prochain appel de fond.</p>
                }
            </Card>
        );
    }
}

CardPaiementPrlManuel.displayName = 'CardPaiementPrlManuel';
CardPaiementPrlManuel.requiredProps = [
    'Pro', // Info du pro
];

function mapStateToProps({
    ProStore: { Pro },
}) {
    return { Pro };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(CardPaiementPrlManuel));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Paiement/CardPaiementPrlManuel.js